export default __webpack_public_path__ + "static/media/hangry-icon.37df9e57.svg";